import {
  OnShelfAvailabilityState,
  REQUEST_ONSHELFAVAILABILITY,
  REQUEST_ONSHELFAVAILABILITY_DONE
} from "./types";

const initialState: OnShelfAvailabilityState = {
  isLoading: true,
  onShelfAvailabilityStatistics: []
};

export function reducer(state = initialState, action: any) {
  switch (action.type) {
    case REQUEST_ONSHELFAVAILABILITY:
      return {
        isLoading: true,
        onShelfAvailabilityStatistics: action.payload
      };
    case REQUEST_ONSHELFAVAILABILITY_DONE:
      return {
        isLoading: false,
        onShelfAvailabilityStatistics: action.payload
      };
    default:
      return state;
  }
}
